import { useDeferredValue, useEffect, useMemo, useState } from 'react'
import { useDispatch } from 'react-redux'
import { CourseItem } from '../../components/courses/CourseItem'
import { CourseList } from '../../components/courses/CourseList'
import { Filter } from '../../components/filter/Filter'
import { FilterDropdown } from '../../components/filter/Filter.Dropdown'
import { SearchBox } from '../../components/filter/Filter.SearchBox'
import { CustomPagination } from '../../components/Pagination/Pagination'
import { useWindowSize } from '../../hooks/useWindowSize'
import { fetchCourses, selectIndustriesOptions, selectSortedCourses } from '../../redux/courseSlice'
import { useAppSelector } from '../../types/assets'
import { CoursesSkeleton } from './CoursesSkeleton'
import { StyledCoursesContainer } from './styles'

export const Courses = () => {
  const dispatch = useDispatch()

  const {
    settings: {
      loading,
      config: { tenantCode },
    },
    courses: {
      loading: { all },
    },
  } = useAppSelector(state => state)

  const courses = useAppSelector(state => selectSortedCourses(state))

  const industriesOptions = useAppSelector(state => selectIndustriesOptions(state))

  const [currentPage, setCurrentPage] = useState(1)

  const [filters, setFilters]: any = useState()

  const [filteredCourses, setFilteredCourses] = useState(courses)

  const { width } = useWindowSize()

  const recordsPerPage = width > 967 ? 9 : 8

  useEffect(() => {
    if (tenantCode && all !== 'succeeded') {
      dispatch(fetchCourses())
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch, tenantCode])

  useEffect(() => {
    if (!filters?.search && !filters?.industries) {
      setFilteredCourses(courses)
    } else {
      const filtered = courses.filter(
        course =>
          (!filters?.search ||
            course?.publishName?.toLocaleLowerCase().includes(filters?.search) ||
            course?.publishCode?.toLocaleLowerCase().includes(filters?.search)) &&
          (filters?.industries === undefined ||
            filters?.industries === 'All Industries' ||
            course?.industry === filters?.industries),
      )
      setFilteredCourses(filtered)
    }
  }, [courses, filters])

  const differedFilteredCourses = useDeferredValue(filteredCourses)
  const pageData = useMemo(
    () =>
      differedFilteredCourses.slice(
        (currentPage - 1) * recordsPerPage,
        (currentPage - 1) * recordsPerPage + recordsPerPage,
      ),
    [currentPage, differedFilteredCourses, recordsPerPage],
  )

  const showLoader = loading === 'loading' || all === 'loading'

  return (
    <StyledCoursesContainer>
      {showLoader ? (
        <CoursesSkeleton />
      ) : (
        <>
          <Filter getFilters={setFilters}>
            <SearchBox
              id="search"
              placeholder="Search for Courses"
            />
            <FilterDropdown
              id="industries"
              label="All Industries"
              options={industriesOptions}
            />
          </Filter>
          <CourseList>
            {pageData.map(course => (
              <CourseItem
                course={course}
                key={course.courseGuid}
              />
            ))}
          </CourseList>
          <CustomPagination
            currentPage={currentPage}
            totalRecords={differedFilteredCourses.length}
            customRecordsPerPage={recordsPerPage}
            onChange={setCurrentPage}
          />
        </>
      )}
    </StyledCoursesContainer>
  )
}
